<template>
  <DialogModalSlotted border-radius-size="small">
    <template #title>
      {{ title }}
    </template>
    <template #body>
      <span v-if="description" v-sanitize-html="description" />

      <BaseCheckbox
        v-if="enableDontShow"
        class="content__checkbox"
        :label="$t('DONT_SHOW_THIS_MESSAGE_AGAIN')"
        :border="false"
        @change="updateDontShow"
      />
    </template>

    <DialogModalActions
      :cancel-text="cancelText"
      :cta-button-text="ctaButtonText"
      :cta-button-theme="ctaButtonTheme"
      @onCancel="cancel"
      @onConfirm="confirm"
    />
  </DialogModalSlotted>
</template>

<script>
import BaseCheckbox from '@/components/generics/base/BaseCheckbox'
import DialogModalActions from './DialogModalActions.vue'
import DialogModalSlotted from './DialogModalSlotted.vue'

export default {
  components: {
    BaseCheckbox,
    DialogModalSlotted,
    DialogModalActions,
  },
  props: {
    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: false,
      default: '',
    },

    enableDontShow: {
      type: Boolean,
      required: false,
      default: false,
    },

    cancelButtonText: {
      type: String,
      required: false,
      default: undefined,
    },

    ctaButtonText: {
      type: String,
      required: true,
    },

    ctaButtonTheme: {
      type: String,
      required: false,
      default: 'blue',
    },
  },

  emits: ['onClose', 'onConfirm'],
  data() {
    return {
      isDontShowChecked: false,
    }
  },

  computed: {
    cancelText() {
      return this.cancelButtonText ?? this.$t('buttons.CANCEL')
    },
  },

  methods: {
    updateDontShow(checked) {
      this.isDontShowChecked = checked
    },

    cancel() {
      this.$emit('onClose')
    },

    /**
     * confirm
     * @emit onConfirm
     * @param isDontShowChecked - The user enabled "Don't show again".
     */
    confirm() {
      this.$emit('onConfirm', this.isDontShowChecked)
    },
  },
}
</script>

<style lang="scss" scoped>
.content__checkbox {
  margin-top: $spacing-2xs;
}
</style>
